<template>
  <div>
    <form @submit.prevent="save" novalidate="true">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ isEdit ? 'עריכת מפתח API' : 'הוספת מפתח API' }}</p>
          <button type="button" class="delete" @click="$emit('close')" />
        </header>
        <section class="modal-card-body">
          <b-field label="שם">
            <b-input v-model="$v.model.Name.$model" />
          </b-field>
          <p v-if="!$v.model.Name.required && $v.model.Name.$error" class="error">שדה חובה</p>

          <b-field label="מייל">
            <b-input v-model="model.Email" />
          </b-field>

          <b-field label="אפליקציות">
            <b-loading :is-full-page="false" v-model="isLoadingApps" />
            <div v-if="!isLoadingApps" class="apps-checkboxes">
              <b-checkbox
                v-for="app in apps"
                :key="app.Id"
                v-model="selectedAppIds"
                :native-value="app.Id"
              >
                {{ app.Name }}
              </b-checkbox>
              <p v-if="!apps.length" class="has-text-grey">אין אפליקציות זמינות</p>
            </div>
          </b-field>
          <p v-if="appError" class="error">יש לבחור לפחות אפליקציה אחת</p>

          <b-field v-if="isEdit" label="פעיל">
            <b-switch v-model="model.IsActive">
              {{ model.IsActive ? 'כן' : 'לא' }}
            </b-switch>
          </b-field>

          <div v-if="isEdit && createdKey" class="created-key-box">
            <b-field label="API KEY">
              <b-input readonly type="password" :value="createdKey.ApiKey" password-reveal />
            </b-field>
            <b-field label="SECRET KEY">
              <b-input readonly type="password" :value="createdKey.ApiSecret" password-reveal />
            </b-field>
          </div>
        </section>
        <footer class="modal-card-foot">
          <b-button native-type="submit" :loading="isSaving" label="שמור" type="is-primary" />
          <b-button :disabled="isSaving" label="סגור" @click="$emit('close')" />
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { ToastProgrammatic as Toast } from 'buefy';
import ProfileService from '@/services/ProfileService';

export default {
  name: 'DialogProfileAppKey',
  props: {
    profileId: { type: Number, required: true },
    keyData: { type: Object, default: null },
    onSuccess: { type: Function, required: true },
  },
  data() {
    const isEdit = !!this.keyData;
    return {
      isEdit,
      isSaving: false,
      isLoadingApps: false,
      apps: [],
      selectedAppIds: isEdit && this.keyData.AppIds ? [...this.keyData.AppIds] : [],
      appError: false,
      createdKey: isEdit ? this.keyData : null,
      model: {
        Name: isEdit ? this.keyData.Name : '',
        Email: isEdit ? this.keyData.Email : '',
        IsActive: isEdit ? this.keyData.IsActive : true,
      },
    };
  },
  validations: {
    model: {
      Name: { required },
    },
  },
  created() {
    this.loadApps();
  },
  methods: {
    async loadApps() {
      this.isLoadingApps = true;
      try {
        const { data } = await ProfileService.getAllApps();
        this.apps = data;
      } catch {
        Toast.open({ type: 'is-danger', message: 'שגיאה בטעינת האפליקציות', duration: 4000 });
      } finally {
        this.isLoadingApps = false;
      }
    },
    async save() {
      this.$v.$touch();
      this.appError = this.selectedAppIds.length === 0;
      if (this.$v.$invalid || this.appError) return;

      this.isSaving = true;
      try {
        if (this.isEdit) {
          const updated = await ProfileService.updateProfileAppKey(this.profileId, this.keyData.UserId, {
            Name: this.model.Name,
            Email: this.model.Email,
            IsActive: this.model.IsActive,
            AppIds: this.selectedAppIds,
          });
          this.createdKey = updated.data;
        } else {
          const created = await ProfileService.createProfileAppKey(this.profileId, {
            Name: this.model.Name,
            Email: this.model.Email,
            AppIds: this.selectedAppIds,
          });
          this.createdKey = created.data;
        }
        this.onSuccess();
        Toast.open({ type: 'is-success', message: 'הפעולה בוצעה!', duration: 4000 });
        this.$emit('close');
      } catch {
        Toast.open({ type: 'is-danger', message: 'קרתה תקלה!', duration: 4000 });
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.apps-checkboxes {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 6px 0;
}
.error {
  color: red;
  font-size: 13px;
  margin-top: -8px;
  margin-bottom: 6px;
}
.created-key-box {
  margin-top: 16px;
  padding: 12px;
  background: #f5f8fa;
  border: 1px solid #cbd6e2;
  border-radius: 4px;
}
</style>
